import styled from 'styled-components';

export const Description = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 130%;
  color: var(--color-text-muted);
`;
